export default {
  ActivityLogImportJob: "Importation du journal d'activité",
  AllSurveysDataMigrationJob: 'Migration des données de tous les formulaires',
  ArenaMobileDataImportJob: 'Importation de données Arena',
  ArenaMobileDataImportSummaryJob: "Résumé de l'importation de données Arena",
  CategoriesImportJob: 'Importation des catégories',
  CategoriesValidationJob: 'Validation des catégories',
  CategoriesBatchImportJob: 'Importation des catégories',
  CategoryImportJob: 'Importation de catégorie',
  CategoryImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportJob: '$t(jobs:CategoryImportJob)',
  CategoryBatchImportInternalJob: '$t(jobs:CategoryImportJob)',
  CategoryValidationJob: 'Validation de catégorie',
  ChainsSamplingNodeDefsCheckJob: "Création des définitions de nœuds d'échantillonnage des chaînes de traitement",
  ChainsValidationJob: 'Validation des chaînes de traitement',
  ChainsImportJob: 'Importation des chaînes',
  CollectDataImportJob: 'Importation de données Collect',
  CollectImportJob: 'Importation Collect',
  CollectSurveyReaderJob: 'Lecteur de formulaire Collect',
  CyclesDeletedCheckJob: 'Vérification des cycles supprimés',
  DataDeleteJob: 'Suppression de données',
  DataImportJob: 'Importation de données',
  DataImportValidationJob: "Validation du fichier d'importation de données",
  EntitiesDeleteJob: 'Suppression des entités existantes',
  FilesImportJob: 'Importation de fichiers',
  MessageSendJob: 'Envoi de message',
  NodeDefsTranslationJob: 'Traduction des libellés des définitions de nœud',
  NodeDefsImportJob: 'Importation des définitions de nœud',
  NodeDefsValidationJob: 'Validation des définitions de nœud',
  OdkImportJob: 'Importation ODK',
  OdkDataImportJob: 'Importation de données ODK',
  OdkFormReaderJob: 'Lecteur de formulaire ODK',
  OdkSubmissionReaderJob: 'Lecteur de soumissions ODK',
  ChainsCyclesCheckJob: `Vérification des cycles de chaînes`,
  RecordCheckJob: "Vérification d'enregistrement",
  RecordsCloneJob: "Clone d'enregistrements",
  RecordsImportJob: "Importation d'enregistrements",
  RecordsImportSummaryJob: "Résumé de l'importation d'enregistrements",
  RecordsUniquenessValidationJob: "Validation de l'unicité des enregistrements",
  SamplingPointDataImportJob: "Importation de données de points d'échantillonnage",
  SamplingPointDataImportInternalJob: "Importation de données de points d'échantillonnage",
  SchemaSummaryExportJob: 'Exportation du résumé du schéma',
  SelectedRecordsExportJob: 'Exportation des enregistrements sélectionnés',
  SurveyActivityLogClearJob: "Effacement du journal d'activité du formulaire",
  SurveyCreatorJob: 'Création de formulaire',
  SurveyDataMigrationJob: 'Migration des données du formulaire',
  SurveyDependencyGraphsGenerationJob: 'Génération du graphe de dépendances du formulaire',
  SurveyExportJob: 'Exportation du formulaire',
  SurveyCompareJob: 'Comparaison de formulaires',
  SurveyCompareDiffJob: 'Calcul des différences',
  SurveyCompareApplyJob: 'Application des modifications du formulaire',
  SurveyFilesImportJob: 'Importation des fichiers du formulaire',
  SurveyIndexGeneratorJob: "Générateur d'index du formulaire",
  SurveyInfoValidationJob: 'Validation des informations du formulaire',
  SurveyLabelsImportJob: 'Importation des étiquettes du formulaire',
  SurveyPropsPublishJob: 'Publication des propriétés du formulaire',
  SurveyPublishJob: 'Publication du formulaire',
  SurveyPublishPerformJob: 'Exécution de la publication du formulaire',
  SurveyRdbCreationJob: 'Création du RDB du formulaire',
  SurveyRdbSchemaCreationJob: 'Création du schéma RDB du formulaire',
  SurveyRdbDataTablesAndViewsCreationJob: 'Création des tables et vues de données RDB du formulaire',
  SurveyRdbOlapDataTablesCreationJob: 'Création des tables de données OLAP RDB du formulaire',
  SurveyUnpublishJob: 'Dépublication du formulaire',
  SurveyPropsUnpublishJob: 'Dépublication des propriétés du formulaire',
  SurveysListExportJob: 'Exportation de la liste des formulaires',
  SurveysRdbRefreshJob: 'Actualisation du RDB des formulaires',
  TaxonomiesImportJob: 'Importation des taxonomies',
  TaxonomiesValidationJob: 'Validation des taxonomies',
  TaxonomyImportJob: 'Importation de taxonomie',
  UsersBackupExportJob: 'Sauvegarde des utilisateurs',
  UsersBackupImportJob: 'Restauration des utilisateurs',
  // exportation de données
  ArenaFileReadJob: 'Lecture de fichier Arena',
  DataExportJob: 'Exportation de données',
  DataMatrixExportJob: 'Exportation de la matrice de données',
  DataSummaryExportJob: 'Exportation du résumé de données',
  ZipCreationJob: 'Création de fichier ZIP',
  CSVDataExtraction: 'Extraction de données',
  FilesExportJob: 'Exportation de fichiers',
  PrepareImportFileJob: "Préparation du fichier d'importation",
  // géo
  GeoJsonDataExportJob: 'Exportation de données GeoJson',
  // importation du formulaire arena
  ArenaImportJob: 'Importation Arena',
  ArenaSurveyReaderJob: 'Lecteur de formulaire Arena',
  CreateRdbJob: 'Création du RDB du formulaire',
  UsersImportJob: 'Importation des utilisateurs',
  // clonage du formulaire
  SurveyCloneJob: 'Clonage du formulaire',
  CloneSurveyJob: 'Clonage du formulaire',
  // sauvegarde du formulaire
  SurveyInfoExportJob: 'Exportation des informations du formulaire',
  CategoriesExportJob: 'Exportation des catégories',
  CategoryGeoPackageExportJob: 'Exportation de catégorie vers GeoPackage',
  SamplingPointDataWhispJob: "Analyse Whisp des données des points d'échantillonnage",
  SamplingPointDataWhispAnalysisJob: 'Analyse Whisp',
  SamplingPointDataWhispCategoryImportJob: 'Importation de la catégorie Whisp',
  TaxonomiesExportJob: 'Exportation des taxonomies',
  RecordsExportJob: 'Exportation des enregistrements',
  RecordFilesExportJob: 'Exportation des fichiers d’enregistrements',
  SurveyFilesExportJob: 'Exportation des fichiers du questionnaire',
  ChainExportJob: 'Exportation de la chaîne',
  UsersExportJob: 'Exportation des utilisateurs',
  ActivityLogExportJob: "Exportation du journal d'activité",
  InfoExportJob: 'Génération des informations du fichier de sortie',
  // rapport de validation
  VaidationReportGenerationJob: 'Génération du rapport de validation',
  // validation des enregistrements
  RecordsValidationJob: `Validation des enregistrements`,
  // analyse
  PersistResultsJob: "Persistance des résultats d'analyse",
  PersistOlapDataJob: 'Persistance des données OLAP',
}
